import { Keys, Scene } from "excalibur";
import { goToScene } from "../../main";
import { createGainedItem, getDescriptionPrice, sendAlert } from "../../utils";
import { gameState, inventoryState } from "../../state/stateManager";
import { Resources } from "../../Resources";
import bee from "./../../../res/bee.png";
import nuc from "./../../../res/nuc.png";
import beePackage from "./../../../res/package.png";
export default class BeesMenu extends Scene {
  constructor() {
    super();
    this.activeItem = 0;
    this.menuItems = 6;
    this.selected = null;
  }
  onActivate() {
    console.log("inside bees");
    this.bees = document.getElementById("bees");
    this.bees.classList.add("activeMenu");
    this.menu = document.getElementById("bees-menu");
    this.menu.classList.add("activeMenuMenu");
    this.commercial = document.getElementById("commercial");
    this.furdland = document.getElementById("furdland");
    this.kozmanian = document.getElementById("kozmanian");
    this.kozUniversity = document.getElementById("koz-university");
    this.maryEllen = document.getElementById("mary-ellen");
    this.rosk = document.getElementById("rosk");
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.selected !== null) {
        this.selected = null;
        this.commercial.classList.remove("activeMenu");
        this.commercial.classList.add("activeProduct");
        this.commercial.innerHTML = `<h1>Commercial</h1>`;
        this.furdland.classList.remove("activeMenu");
        this.furdland.classList.remove("activeProduct");
        this.kozmanian.classList.remove("activeMenu");
        this.kozmanian.classList.remove("activeProduct");
        this.kozUniversity.classList.remove("activeMenu");
        this.kozUniversity.classList.remove("activeProduct");
        this.maryEllen.classList.remove("activeMenu");
        this.maryEllen.classList.remove("activeProduct");
        this.rosk.classList.remove("activeMenu");
        this.rosk.classList.remove("activeProduct");
        this.furdland.innerHTML = `<h1>Furdland</h1>`;
        this.kozmanian.innerHTML = `<h1>Kozmanian</h1>`;
        this.kozUniversity.innerHTML = `<h1>Koz University</h1>`;
        this.maryEllen.innerHTML = `<h1>Mary Ellen</h1>`;
        this.rosk.innerHTML = `<h1>Rosk</h1>`;
        this.menuItems = 6;
        this.activeItem = 0;
      } else {
        goToScene("onlineMarket");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Left)) {
      Resources.Click.play();
      if (this.activeItem === 0) {
        this.activeItem = this.menuItems - 1;
      } else {
        this.activeItem = this.activeItem - 1;
      }

      console.log("pressed left, active is: ", this.activeItem);
      if (this.selected !== null) {
        //show proper bee type
        console.log("calling selectpackage");
        this.selectNucPackageQueen();
      } else {
        this.showProperItem();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Right)) {
      Resources.Click.play();
      if (this.activeItem === this.menuItems - 1) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
      console.log("pressed right active is ", this.activeItem);
      if (this.selected !== null) {
        //show proper bee type
        console.log("calling selectpackage");
        this.selectNucPackageQueen();
      } else {
        this.showProperItem();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      if (this.selected !== null) {
        console.log("inside enterPress, selected not null");
        let type;
        switch (this.selected) {
          case 0:
            type = "commercial";
            break;
          case 1:
            type = "furdland";
            break;
          case 2:
            type = "kozmanian";
            break;
          case 3:
            type = "kozUniversity";
            break;
          case 4:
            type = "maryEllen";
            break;
          case 5:
            type = "rosk";
            break;
          default:
            break;
        }
        let info = getDescriptionPrice(type);
        console.log("enterPress calling buyBees");
        this.buyBees(info, type);
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (this.selected === null) {
        this.openProperBee();
        this.activeItem = 0;
        this.menuItems = 3;
      }
    }
  }
  buyBees(info, type) {
    console.log("inside buyBees enterpress");
    let balance = gameState.getCoins();
    let inventory = inventoryState.getInventory();
    if (this.activeItem == 0) {
      //buy nuc
      if (balance > info.price.nuc) {
        let nucs = [...inventory.nucs];
        if (nucs == null || nucs == undefined) {
          nucs = [];
        }
        nucs.push({ breed: type });
        inventory.nucs = nucs;
        Resources.Coins.play();
        gameState.setCoins(balance - info.price.nuc);
        createGainedItem(type + " Nuc");
      } else {
        Resources.Error.play();
        sendAlert("Not Enough Coins");
      }
    } else if (this.activeItem == 1) {
      //buy package
      if (balance > info.price.package) {
        let packages = [...inventory.packages];
        if (packages == null || packages == undefined) {
          packages = [];
        }
        packages.push({ breed: type });
        inventory.packages = packages;
        Resources.Coins.play();
        gameState.setCoins(balance - info.price.package);
        createGainedItem(type + "Package");
      } else {
        Resources.Error.play();
        sendAlert("Not Enough Coins");
      }
    } else if (this.activeItem == 2) {
      //buy queen
      if (balance > info.price.queen) {
        let queens = [...inventory.queens];
        if (queens == null || queens == undefined) {
          queens = [];
        }
        queens.push({ breed: type });
        inventory.queens = queens;
        Resources.Coins.play();
        gameState.setCoins(balance - info.price.queen);
        createGainedItem(type + "queen");
      } else {
        sendAlert("Not Enough Coins");
        Resources.Error.play();
      }
    }
  }
  selectNucPackageQueen() {
    let beeType;
    switch (this.selected) {
      case 0:
        beeType = "commercial";
        break;
      case 1:
        beeType = "furdland";
        break;
      case 2:
        beeType = "kozmanian";
        break;
      case 3:
        beeType = "kozUniversity";
        break;
      case 4:
        beeType = "maryEllen";
        break;
      case 5:
        beeType = "rosk";
        break;
      default:
        break;
    }
    let nuc = document.getElementById(`${beeType}-nuc`);
    let packageDiv = document.getElementById(`${beeType}-package`);
    let queen = document.getElementById(`${beeType}-queen`);
    console.log(
      "inside selectPackagequeen etc, type is : ",
      beeType,
      " active is :",
      this.activeItem
    );
    if (this.activeItem === 0) {
      nuc.classList.add("activeProduct");
      packageDiv.classList.remove("activeProduct");
      queen.classList.remove("activeProduct");
    } else if (this.activeItem === 1) {
      nuc.classList.remove("activeProduct");
      packageDiv.classList.add("activeProduct");
      queen.classList.remove("activeProduct");
    } else if (this.activeItem === 2) {
      nuc.classList.remove("activeProduct");
      packageDiv.classList.remove("activeProduct");
      queen.classList.add("activeProduct");
    }
  }
  openProperBee() {
    switch (this.activeItem) {
      case 0:
        this.selected = 0;
        this.commercial.classList.add("activeMenu");
        this.furdland.classList.remove("activeMenu");
        this.kozmanian.classList.remove("activeMenu");
        this.kozUniversity.classList.remove("activeMenu");
        this.maryEllen.classList.remove("activeMenu");
        this.rosk.classList.remove("activeMenu");
        this.commercial.innerHTML = this.getInnerHtml(this.selected);
        break;
      case 1:
        this.selected = 1;
        this.commercial.classList.remove("activeMenu");
        this.furdland.classList.add("activeMenu");
        this.kozmanian.classList.remove("activeMenu");
        this.kozUniversity.classList.remove("activeMenu");
        this.maryEllen.classList.remove("activeMenu");
        this.rosk.classList.remove("activeMenu");
        this.furdland.innerHTML = this.getInnerHtml(this.selected);
        break;
      case 2:
        this.selected = 2;
        this.commercial.classList.remove("activeMenu");
        this.furdland.classList.remove("activeMenu");
        this.kozmanian.classList.add("activeMenu");
        this.kozUniversity.classList.remove("activeMenu");
        this.maryEllen.classList.remove("activeMenu");
        this.rosk.classList.remove("activeMenu");
        this.kozmanian.innerHTML = this.getInnerHtml(this.selected);
        break;
      case 3:
        this.selected = 3;
        this.commercial.classList.remove("activeMenu");
        this.furdland.classList.remove("activeMenu");
        this.kozmanian.classList.remove("activeMenu");
        this.kozUniversity.classList.add("activeMenu");
        this.maryEllen.classList.remove("activeMenu");
        this.rosk.classList.remove("activeMenu");
        this.kozUniversity.innerHTML = this.getInnerHtml(this.selected);
        break;
      case 4:
        this.selected = 4;
        this.commercial.classList.remove("activeMenu");
        this.furdland.classList.remove("activeMenu");
        this.kozmanian.classList.remove("activeMenu");
        this.kozUniversity.classList.remove("activeMenu");
        this.maryEllen.classList.add("activeMenu");
        this.rosk.classList.remove("activeMenu");
        this.maryEllen.innerHTML = this.getInnerHtml(this.selected);
        break;
      case 5:
        this.selected = 5;
        this.commercial.classList.remove("activeMenu");
        this.furdland.classList.remove("activeMenu");
        this.kozmanian.classList.remove("activeMenu");
        this.kozUniversity.classList.remove("activeMenu");
        this.maryEllen.classList.remove("activeMenu");
        this.rosk.classList.add("activeMenu");
        this.rosk.innerHTML = this.getInnerHtml(this.selected);
        break;
      default:
        break;
    }
  }
  getInnerHtml(index) {
    console.log("inside getInnerHtml, index is: ", index);
    let info;
    switch (index) {
      case 0:
        info = getDescriptionPrice("commercial");
        return this.showBeeOptions(info, "commercial");
        break;
      case 1:
        info = getDescriptionPrice("furdland");
        return this.showBeeOptions(info, "furdland");
        break;
      case 2:
        info = getDescriptionPrice("kozmanian");
        return this.showBeeOptions(info, "kozmanian");
        break;
      case 3:
        info = getDescriptionPrice("kozUniversity");
        return this.showBeeOptions(info, "kozUniversity");
        break;
      case 4:
        info = getDescriptionPrice("maryEllen");
        return this.showBeeOptions(info, "maryEllen");
        break;
      case 5:
        info = getDescriptionPrice("rosk");
        return this.showBeeOptions(info, "rosk");
        break;
      default:
        break;
    }
  }
  showBeeOptions(info, type) {
    console.log("inside showBeeOptions: info: ", info);
    return `<h1>${type}</h1>
        <img src="${bee}"/>
        <p class="bee-description">${info.description}</p>
        <div class="bee-menu">
        <div id="${type}-nuc" class="buyable activeProduct"><img class="typeSprite" src="${nuc}"/>Nucleus Colony - $${info.price.nuc}</div>
        <div id="${type}-package" class="buyable"><img class="typeSprite" src="${beePackage}"/>Package - $${info.price.package}</div>
        <div id="${type}-queen" class="buyable"><img class="typeSprite" src="${bee}"/>Queen - $${info.price.queen}</div></div>
        <h3>Arrow Keys> Navigate <br/> SPACE> Buy Item <br/> X> Back</h3>
        `;
  }
  showProperItem() {
    switch (this.activeItem) {
      case 0:
        this.commercial.classList.add("activeProduct");
        this.furdland.classList.remove("activeProduct");
        this.kozmanian.classList.remove("activeProduct");
        this.kozUniversity.classList.remove("activeProduct");
        this.maryEllen.classList.remove("activeProduct");
        this.rosk.classList.remove("activeProduct");
        break;
      case 1:
        this.commercial.classList.remove("activeProduct");
        this.furdland.classList.add("activeProduct");
        this.kozmanian.classList.remove("activeProduct");
        this.kozUniversity.classList.remove("activeProduct");
        this.maryEllen.classList.remove("activeProduct");
        this.rosk.classList.remove("activeProduct");
        break;
      case 2:
        this.commercial.classList.remove("activeProduct");
        this.furdland.classList.remove("activeProduct");
        this.kozmanian.classList.add("activeProduct");
        this.kozUniversity.classList.remove("activeProduct");
        this.maryEllen.classList.remove("activeProduct");
        this.rosk.classList.remove("activeProduct");
        break;
      case 3:
        this.commercial.classList.remove("activeProduct");
        this.furdland.classList.remove("activeProduct");
        this.kozmanian.classList.remove("activeProduct");
        this.kozUniversity.classList.add("activeProduct");
        this.maryEllen.classList.remove("activeProduct");
        this.rosk.classList.remove("activeProduct");
        break;
      case 4:
        this.commercial.classList.remove("activeProduct");
        this.furdland.classList.remove("activeProduct");
        this.kozmanian.classList.remove("activeProduct");
        this.kozUniversity.classList.remove("activeProduct");
        this.maryEllen.classList.add("activeProduct");
        this.rosk.classList.remove("activeProduct");
        break;
      case 5:
        this.commercial.classList.remove("activeProduct");
        this.furdland.classList.remove("activeProduct");
        this.kozmanian.classList.remove("activeProduct");
        this.kozUniversity.classList.remove("activeProduct");
        this.maryEllen.classList.remove("activeProduct");
        this.rosk.classList.add("activeProduct");
        break;
      default:
        break;
    }
  }
  onDeactivate() {
    this.bees.classList.remove("activeMenu");
    this.menu.classList.remove("activeMenuMenu");
  }
}
